import React, {Component} from 'react'
import logo from '../img/logo.png'
import '../styles/Header.css'
import '../styles/Admin.css'
import {Link} from "react-router-dom";
import AppConfig from "../AppConfig";

export default class HeaderAdmin extends Component {

    render() {
        return <div className="container-fluid adminHeader">
            <div className="Header row" style={{paddingTop: 5}}>
                <div className="col-sm-6">
                    <Link to='/admin'><a className="navbar-brand"><img src={logo}
                                                                       className="logo"/></a></Link><font
                    style={{paddingTop: 25, fontSize: 12, color: '#57b13c'}}>{AppConfig.DATE_OF_MODIFICATION()}</font>
                </div>
                <div className="col-sm-6 text-right">

                    <div style={{paddingTop: 10}}><font style={{fontWeight: 'bold'}}>Administrator</font><Link
                        to='/admin'><i onClick={() => sessionStorage.removeItem('adminLoggedIn')}
                                       className="fa fa-power-off" style={{
                        marginRight: 5,
                        marginLeft: 10,
                        padding: 10,
                        color: 'white',
                        background: '#dc0606', borderRadius: 5, cursor: 'pointer'
                    }} aria-hidden="true"> </i></Link>
                    </div>

                </div>
            </div>
        </div>

    }
}



// WEBPACK FOOTER //
// ./src/components/shared/HeaderAdmin.js